import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { distinctUntilChanged, filter, map, shareReplay, take } from 'rxjs/operators';
import { LoaderService } from './services/loader.service';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})


export class AppComponent {
    title = 'e-transporte';
    routePath$;

    isLoading$: Subject<boolean> = this._loaderService.isLoading;

    constructor(
        private _router: Router,
        private _loaderService: LoaderService,
        private _route: ActivatedRoute,
        private _location: Location
    ) {
        this.routePath$ = this._router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            map(() => {
                let route = this._route.firstChild;
                let child = route;
                while (child) {
                    if (child.firstChild) {
                        child = child.firstChild;
                        route = child;
                    } else {
                        child = null;
                    }
                }
                return route;
            }),
            distinctUntilChanged(),
            // replays the latest NavigationEnd emissions on subscription: https://www.learnrxjs.io/operators/multicasting/sharereplay.html
            shareReplay(),
        );
        // force shareReplay to be able to listen to the NavigationEnd event that happens only in constructor
        this.routePath$.pipe(take(1)).subscribe();
    }

    async ngOnInit() {
        this.routePath$.subscribe(route => this.handleRouteEvent(route));
    }

    async handleRouteEvent(route: any) {
        if (route.data && route.data.title) {
            // this._moduleService.listen.next(route.data.title);
        }
        if (route.snapshot.data.form) {
            let dialog = await route.snapshot.data.form(route.snapshot.params);
            dialog.afterClosed().subscribe(async r => {
                if (window.history.length > 1) {
                    this._location.back();
                }
            })
        }
    }
}
